// chart/variants/grid_only_variant.js

import { buildBaseOptions } from '../base_options'

export const GridOnlyVariant = {
  chartType: 'line',

  applyDataDefaults() {},

  buildOptions(options = {}) {
    return buildBaseOptions(options)
  },
}
